import { isTag, isTextNode } from 'anodum';
import { IMAGE_TAG } from '../constants/editable-elements';
import isInlineElement from './is-inline-element';
import isContentEditableAncestor from './is-content-editable-ancestor';

const isElementToWrap = (element, rootElement) => {
  if (!isContentEditableAncestor(rootElement)) return false;

  if (isTextNode(element) || (isInlineElement(element) && !isTag(element, IMAGE_TAG))) {
    return element.parentNode === rootElement;
  }

  return false;
};

export default isElementToWrap;
